import React, { useState, useEffect } from 'react';

const DimensionScores = ({ scores }) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setTimeout(() => setAnimate(true), 100);
  }, []);

  const dimensions = [
    { name: 'Character',           value: scores.mentalFit,    color: '#7E57C2', delay: 0 },
    { name: 'Athletic Ability',    value: scores.physicalFit,  color: '#00E676', delay: 100 },
    { name: 'Position Performance',value: scores.skillFit,     color: '#FFB300', delay: 200 },
    { name: 'Projection',          value: scores.schemeFit,    color: '#00D4FF', delay: 300 },
    { name: 'Academic Profile',    value: scores.contextFit,   color: '#546E7A', delay: 400 },
  ];

  return (
    <div className="panel-card fade-in">
      <h2 className="text-white font-bold text-lg mb-4">Dimension Scores</h2>
      <div className="flex flex-col gap-4">
        {dimensions.map((dim) => (
          <div
            key={dim.name}
            className={`flex items-center gap-4 ${animate ? 'slide-in-left' : 'opacity-0'}`}
            style={{ animationDelay: `${dim.delay}ms` }}
          >
            <div className="w-24 md:w-40 text-[#B0BEC5] text-xs md:text-sm font-medium flex-shrink-0">{dim.name}</div>
            <div className="flex-1 relative">
              <div className="w-full h-6 md:h-8 bg-[#243B55] rounded-full overflow-hidden">
                <div
                  className="h-full rounded-full transition-all duration-1000 ease-out"
                  style={{
                    width: animate ? `${(dim.value / 9) * 100}%` : '0%',
                    backgroundColor: dim.color,
                    boxShadow: `0 0 20px ${dim.color}40`
                  }}
                />
              </div>
            </div>
            <div className="w-12 text-right font-rajdhani font-bold text-xl" style={{ color: dim.color }}>
              {dim.value}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DimensionScores;
